import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { toggleSwitch } from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { CUSTOMER_QC_PREAPPROVAL_REQUIRED } from "MODULES/SalesOrders/constants";
import { ConfirmAction, Icon } from "MODULES/shared/components";
import * as actions from "MODULES/SalesOrders/actions";
import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";
import { WAREHOUSE_EXPERT } from "MODULES/users/constants";

function QcPreapproved({ lineItem, confirm, confirming, close, open }) {
  const currentUser = useCurrentUser();
  if (
    !lineItem[CUSTOMER_QC_PREAPPROVAL_REQUIRED] ||
    currentUser.subrole !== WAREHOUSE_EXPERT
  ) {
    return null;
  }

  return (
    <DropDownItem onClick={open}>
      <Icon name="check" fixed />
      <span className="with-padding">QC paperwork approved</span>
      <ConfirmAction onConfirm={confirm} close={close} open={confirming}>
        <strong>Heads up! </strong>
        <span className="with-padding">Are you sure you want to approve?</span>
      </ConfirmAction>
    </DropDownItem>
  );
}

QcPreapproved.propTypes = {
  lineItem: T.shape({}),
  confirm: T.func.isRequired,
  confirming: T.func.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  confirm: () =>
    dispatch(
      actions.updateLineItem(ownProps.lineItem.id, {
        [CUSTOMER_QC_PREAPPROVAL_REQUIRED]: false
      })
    )
}))(toggleSwitch("confirming")(QcPreapproved));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/QcPreapproved/QcPreapproved.jsx